import api from './api';

const servicioService = {
  // Obtener todos los servicios con información mejorada
  getServiciosEnhanced: async () => {
    try {
      const response = await api.get('/api/ServiceRequests');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener estadísticas mensuales por empresa (optimizado)
  getMonthlyCompanyStats: async (year = null, month = null) => {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);

      const queryString = params.toString();
      const url = `/api/ServiceRequests/monthly-company-stats${queryString ? `?${queryString}` : ''}`;

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener estadísticas anuales de empresas (todos los 12 meses en un solo llamado)
  getYearlyCompanyStats: async (year) => {
    try {
      const response = await api.get(`/api/ServiceRequests/yearly-company-stats?year=${year}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener servicios detallados por empresa y mes
  getCompanyMonthlyServices: async (companyId, year = null, month = null) => {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);

      const queryString = params.toString();
      const url = `/api/ServiceRequests/company-monthly-services/${companyId}${queryString ? `?${queryString}` : ''}`;

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener estadísticas mensuales por partners (inmobiliarias y empresas PH)
  getMonthlyPartnerStats: async (year = null, month = null) => {
    try {
      const url = `/api/PercentageToBePaidToUser/by-month?Year=${year}&Month=${month}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTotalPaidPreviousMonths: async () => {
    try {
      const url = "/api/PercentageToBePaidToUser/total-paid-previous-months";
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updatePartnerStatus: async (data) => {
    try {
      const url = `/api/PercentageToBePaidToUser/${data.partnerId}`;
      const response = await api.put(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener servicios detallados por partner y mes
  getPartnerMonthlyServices: async (partnerId, year, month) => {
    try {
      const url = `/api/PercentageToBePaidToUser/leads-by-month/${partnerId}?Year=${year}&Month=${month}`;
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar un servicio
  deleteServicio: async (id) => {
    try {
      const response = await api.delete(`/api/ServiceRequests/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener la cantidad de servicios por usuario
  getServiciosPorUsuario: async () => {
    try {
      const response = await api.get('/api/ServiceRequests');
      const servicios = response.data;
      const contadorServicios = {};

      if (Array.isArray(servicios)) {
        servicios.forEach(servicio => {
          const userId = servicio.userId || servicio.user?.id;
          if (userId) {
            if (!contadorServicios[userId]) {
              contadorServicios[userId] = 0;
            }
            contadorServicios[userId]++;
          }
        });
      }
      return contadorServicios;
    } catch (error) {
      throw error;
    }
  },

  // Obtener servicios con paginación y filtros
  getServiciosFiltered: async (page = 1, pageSize = 10, filters = {}) => {
    try {
      // Construir parámetros de consulta
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString()
      });

      // Agregar filtros si están presentes
      if (filters.fromDate) {
        params.append('fromDate', filters.fromDate);
      }
      if (filters.toDate) {
        params.append('toDate', filters.toDate);
      }
      if (filters.userName) {
        params.append('userName', filters.userName);
      }
      if (filters.companyName) {
        params.append('companyName', filters.companyName);
      }
      if (filters.serviceName) {
        params.append('serviceName', filters.serviceName);
      }
      if (filters.search) {
        params.append('search', filters.search);
      }

      const response = await api.get(`/api/ServiceRequests/filtered?${params.toString()}`);
      return response.data;
    } catch (error) {

      // Fallback: si el backend no soporta filtros, usar solo paginación básica
      try {
        const fallbackResponse = await api.get(`/api/ServiceRequests/filtered?page=${page}&pageSize=${pageSize}`);
        return fallbackResponse.data;
      } catch (fallbackError) {
        throw fallbackError;
      }
    }
  },

  updateAmountDue: async (id, data) => {
    try {
      const url = `/api/payments/amount-due/${id}`;
      const response = await api.put(url, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validar contraseña y procesar cobro
  processCharge: async (chargeData, password, id) => {
    const headers = {
      'pass': password,
      'chargeId': id
    };
    try {
      const response = await api.post('/api/payments/charge-by-company', chargeData, { headers });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default servicioService;
